// plugin.js

// This exports the plugin object.
export default {
    shuffle: function (arr) {
        for (let i = arr.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [arr[i], arr[j]] = [arr[j], arr[i]];
        }
    },

    // The install method will be called with the Vue constructor as
    // the first argument, along with possible options
    install(Vue) {
        Vue.$array = { shuffle: this.shuffle }
        Vue.prototype.$array = { shuffle: this.shuffle }
    }
}